import { css } from 'styled-components'

export const lightScrollbarInChromeStyle = css`
  -webkit-overflow-scrolling: touch;

  @supports not (-moz-force-broken-image-icon: 1) {
    scrollbar-width: thin;
  }
`
